export enum DATA_DISPLAY_CARD_STYLE {
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCESS = 'SUCCESS',
  DEFAULT = 'DEFAULT',
  REJECTED = 'REJECTED'
};

export interface DataCardItem {
  dataValue?: number | string;
  theme?: string;
  cardTitle?: string;
  cardIcon?: string;
}